import styled from "styled-components";
import { StyledHeader, HeaderOverlay, HeaderBorder, GradientText,FlexContainer } from "../styled";
import shinyEffect from "../../assets/images/shinyEffect.png";
import { useEffect ,useState} from "react";
import dropdownOpenedIcon from "../../assets/icons/dropdownIconOpened.png";
import dropdownClosedIcon from "../../assets/icons/dropdownIconClosed.png";
import {useDeck} from "../../context/DeckContext";
import { getDungeons,updateDungeon } from "../../service/main/api";
import {useUserContext} from "../../context/UserContext";
import { useToaster } from "../../hooks/useToaster";
import { useBottomSheet } from "../../context/BottomSheetContext";
import ChangeDungeonConfirmModalContent from "../changeDungeonConfirmModalContent";
import InfoModalContentBacground from "../../assets/images/background/dungeonInfoModalBackground.svg";
import CustomInfoIcon from "../../assets/icons/customInfoIcon.png";
import CustonCloseIcon from "../../assets/icons/customCloseIcon.png";
import AboutIcon from "../../assets/icons/about.png";
import ReactMarkdown from 'react-markdown'

const GameHeader = (props) =>{
    const [pageName, setPageName] = useState(props?.title);
    const [dungeons, setDungeons] = useState([]);
    const [infoModalOpened, setInfoModalOpened] = useState(false);
    const [selectedDungeon, setSelectedDungeon] = useState(null);
    const {deck} = useDeck();
    const {user,fetchUser} = useUserContext();
    const [dropdownOpened, setDropdownOpened] = useState(false);
    const {showToaster} = useToaster();
    const {openSheet,closeSheet} = useBottomSheet();

    useEffect(() => {
        if(deck){
            handleDungeon();
        }
    }, [deck])
    const handleDungeon = async () => {
        const res = await getDungeons();
        if(res?.success){
            setDungeons(res.data);          
            setPageName(deck.dungeon.name);
        }
    }
    const changeDungeon =async (dungeon) => {
        try {
            if(user.energy  === 0){
                showToaster({message:"You should recharge you energy",type:"error"});
                return;
            }
            openSheet({
                content: <ChangeDungeonConfirmModalContent changeDungeon={()=>handleDungeonChange(dungeon)} onClose={closeSheet} />,
            });

        } catch (error) {
            console.error("Error updating dungeon", error);
        }       
    }
    const handleDungeonChange = async (dungeon) => {
        const res = await updateDungeon({dungeon:dungeon});
        if(res?.success){
            await fetchUser();
            closeSheet();
            setPageName(dungeon.name);
            setDropdownOpened(false);
           
        }else{
            closeSheet();
            setDropdownOpened(false);
            showToaster({message:res.message,type:"error"});
        }  
    };
    const handleDungeonInfo = (dungeon) => {
        setSelectedDungeon(dungeon);
        setInfoModalOpened(true
        );
    };
    return(<>
            <StyledHeader>
            <ShinnyImage src={shinyEffect} alt="Shinny Effect" />
            <PageTitleContainer gap="8px">
                <HeaderText>{pageName}</HeaderText>
                <DropdownIcon src={
                    dropdownOpened ? dropdownOpenedIcon : dropdownClosedIcon
                } onClick={() => setDropdownOpened(!dropdownOpened)} />
            </PageTitleContainer>
        <CustomHeader>
            <HeaderBorder style={{ top: 0 }} />
            <HeaderOverlay />
        </CustomHeader>
    </StyledHeader>
    <DropdownContainer opened={dropdownOpened}>
    {dungeons.map(dungeon => (
        <DropdownItem  selected={dungeon._id === deck.dungeon._id} key={dungeon._id}>
            <FlexContainer onClick={()=>changeDungeon(dungeon)} style={{width:"80%",height:"100%",alignItems:"center",justifyContent:"flex-start"}}>
            <DropdownCirkle selected={dungeon._id === deck.dungeon._id}/> {dungeon.name}
            </FlexContainer>
           
           <img src={AboutIcon} alt="about" onClick={()=>handleDungeonInfo(dungeon)} />
        </DropdownItem>
    ))}
   </DropdownContainer>
          <DungeonInfoModalContainer opened={infoModalOpened}>
            <FlexContainer style={{position:"relative",maxWidth:"412px"}}>
            <CustomInfoIconImage src={CustomInfoIcon} alt="Custom Info Icon"/>
            <CustomCloseIconImage src={CustonCloseIcon} alt="Custom Close Icon" onClick={()=>setInfoModalOpened(false)} />
            <DungeonInfoModal>
                <InfoModalBackground src={InfoModalContentBacground} alt="Dungeon Info Modal Background" />
                <InfoModalContent>
                <InfoModalTitle> {selectedDungeon?.name} </InfoModalTitle>
                <InfoModalDescriptionContainer>
                    <ReactMarkdown>
                    {selectedDungeon?.description}
                    </ReactMarkdown>
                </InfoModalDescriptionContainer>
                </InfoModalContent>
            </DungeonInfoModal>
            </FlexContainer>
          </DungeonInfoModalContainer>
          </>
    )
}
const CustomHeader = styled(StyledHeader)`
    background: linear-gradient(90deg, #635DC2 0%, #9090FB 42%, #635DC2 100%);
    top: -1vh;
`;
const HeaderText = styled(GradientText)`
    font-size: 1.2em;
    font-weight: 700;
    text-transform: capitalize;
`;
const ShinnyImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 3;
`;
const PageTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 16px;
    z-index: 5;
    gap: ${props => props.gap || "0"};
    
`
const DropdownIcon = styled.img`
        cursor: pointer;
    `;
const DropdownContainer = styled.div`
    position: fixed;
    top:calc(77px + var(--tg-safe-area-inset-top, 0px));
    width: 290px;
    background:rgba(28, 54, 146, 0.39);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    gap: 4px;
    border-radius: 17px;
    border: 2px solid;
    border-image: linear-gradient(180deg, #CBC6FF 0%, #CBC6FF 46%, #8E84FF 100%);
    display: ${props => props.opened ? "flex" : "none"};
`
const DropdownItem = styled.div`
    width: 100%;
    height: 48px;
    border-radius: 10px;
    padding:0 8px;
    display: flex;
    align-items: center;
    border: 2px solid #CBC6FF59; 
    justify-content:flex-start;
    background: ${props => props.selected ? "linear-gradient(180deg, #FAD2FF 0%,  #67316E 50%, #9D4BA8 100%)" : "transparent"};
    cursor: pointer;
    img{
        position: absolute;
        right: 18px;
        cursor: pointer;
    }
`
const DropdownCirkle = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background:transparent;
    margin-right: 8px;
    border: 2px solid ;
    border-color: ${props => props.selected ? "#fff" : "#CBC6FF59"};
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: ${props => props.selected ? "white" : "transparent"};
    }
`
const DungeonInfoModalContainer = styled.div`
     width: 100%;
     height: 100%;
     position: fixed;
     top: 0;
     left: 0;
     display: ${props => props.opened ? "flex" : "none"};
     align-items: center;
     justify-content: center;
     z-index: 10;
     padding: 0 16px;
     background: #0000008F;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
`
const DungeonInfoModal = styled.div`
    width: 100%;
    aspect-ratio: 358/466;
    max-width: 412px; 
    position: relative; 
`
const InfoModalBackground = styled.img`
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
`
const InfoModalContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 10;
    padding-top:65px;
    padding-left: 16px;
    padding-right: 16px;
    align-items: center;
`
const InfoModalTitle = styled(GradientText)`
    font-size: 1.7em;
    font-weight: 700;
    text-transform: capitalize;
    margin-bottom: 32px;
    line-height:1.5
`
const InfoModalDescriptionContainer = styled.div`
    font-size: 12px;
    font-weight: 400;
    max-width:270px;
    ul{
        list-style-type: disc;
        padding-left: 16px;
        li{
            margin-bottom: 5px;
        }
    }
`
const CustomInfoIconImage = styled.img`
    position: absolute;
    top: -44px;
    left: -8px;
    z-index: 10;
`
const CustomCloseIconImage = styled.img`
    position: absolute;
    top: -64px;
    right: -8px;
    z-index: 10;
    cursor: pointer;
`
export default GameHeader;
